import { z } from "zod";

export const riderSchema = z.object({
  name: z.string().min(1, "Nama rider wajib diisi"),
  workspaceId: z.string().optional(),
});

export type RiderFormValues = z.infer<typeof riderSchema>;

export const defaultRiderValues: RiderFormValues = {
  name: "",
  workspaceId: "",
};
